// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"comparisonHeader_tableHead__2qnV1"};